import { Fields } from "../Fields/field-model";

export class AddCategoryFieldModel {
  public categoryID: number;
  public Fields: Fields[];
}



// WEBPACK FOOTER //
// ./src/app/models/category/AddCategoryField.model.ts